import React, {FC, useState} from "react";
import './courseCards.scss';
import avatarPlaceholder from "../../../../assets/placeholder/avatar_placeholder.png";
import ToggleSwitch from "../../ToggleSwitch";
import BoardForm from "../BoardForm";
import DeleteAlert from "../../DeleteAlert";
import * as appRoutes from "../../../../routes/routeConstants/appRoutes";
import {withRouter,generatePath, RouteComponentProps} from "react-router-dom";
import CardMenu from "../CardMenu";
import BoardService from "../../../../services/CourseServices/BoardService/board.service";
import {convertJSONToFormData} from "../../../utils/converJsonToFormData";
import {Badge} from "antd"
interface CourseCardsProps extends RouteComponentProps{
    courses:any;
    refreshList: Function;
    currentPageNumber: number;
}

const CourseCards:FC<CourseCardsProps> = (props) => {

    const {courses, refreshList, currentPageNumber} = props;

    const [formVisible,setFormVisible] = useState<boolean>(false);
    const [deleteVisible,setDeleteVisible] = useState<boolean>(false);
    const [currentCourse,setCurrentCourse] = useState<any>('');

    const handleStatusToggle = (courseId:number,checked:boolean) => {
        const jsonData = {board:{is_active: checked}};
        const boardFormData = convertJSONToFormData(jsonData);
        BoardService.updateBoard(courseId,
            boardFormData,
            ()=>{
                refreshList(currentPageNumber)
            },
            ()=>{},
            ()=>{},
        ).then()
    }

    const handleDelete = () => {
        BoardService.deleteBoard(currentCourse.id,
            ()=>{
                refreshList(currentPageNumber)
                setDeleteVisible(false)
            },
            ()=>{},
            ()=>{},
        ).then()
    }

    return(
        <div>
            <BoardForm title="Edit Board"
                       visible={formVisible}
                       setVisible={setFormVisible}
                       data={currentCourse}
                       refreshList={refreshList}
                       currentPageNumber={currentPageNumber}
            />
            <DeleteAlert title={currentCourse?.acronym}
                         logo={currentCourse?.displayPictureUrl}
                         detail={currentCourse?.name}
                         visible={deleteVisible}
                         setVisible={setDeleteVisible}
                         deleteText='board'
                         deleteWarning='This board will be deleted permanently'
                         handleDelete={handleDelete}
            />
            {courses.map((course:any) =>
                <div className='course__card' key={course.id} onClick={()=>{
                    props.history.push(generatePath(appRoutes.COURSE_CLASS,{boardName:course.acronym,boardId:course.id}))
                }}>
                    <div className='course__logo rounded'>
                        <img src={course.displayPictureUrl || avatarPlaceholder} alt=''/>
                    </div>
                    <div className='course__details'>
                        <div className='course__acronym'>{course.acronym}</div>
                        <div className='course__title'>{course.name}{" "}<Badge className="badge__separator" status="default" />{" "}ID: {course.id}</div>
                        {/* <div className='course__id'>ID: {course.id}</div> */}
                    </div>
                    <div className='course__toggle' onClick={(event)=>event.stopPropagation()}>
                        <ToggleSwitch checked={course.isActive}
                                      handleChange={(checked:boolean)=>handleStatusToggle(course.id,checked)}
                        />
                    </div>
                    <div className='course-menu-trigger' onClick={(event)=>{
                        event.stopPropagation();
                        setCurrentCourse(courses.filter((obj:any) => obj.id === course.id )[0])
                    }}>
                        <CardMenu menuText='Board'
                                  handleEdit={setFormVisible}
                                  handleDelete={setDeleteVisible}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default withRouter(CourseCards);
